import { render, staticRenderFns } from "./payment-user-page.vue?vue&type=template&id=ae5b00cc&scoped=true"
import script from "./payment-user-page.vue?vue&type=script&lang=js"
export * from "./payment-user-page.vue?vue&type=script&lang=js"
import style0 from "./payment-user-page.vue?vue&type=style&index=0&id=ae5b00cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b00cc",
  null
  
)

export default component.exports